<button
  class="btn"
  (click)="openModal()"
  [ngClass]="big ? 'btn-primary btn-lg' : 'btn-secondary'">
  {{ label }}
  <i class="icon-chat ms-2"></i>
</button>
